/* ============================================================
   nav-drawer.js
   Menu tiroir principal — Shopify
   Thème : Beelive Studio — interception du header-drawer natif
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    const drawer   = document.querySelector('.nd-drawer');
    const overlay  = document.querySelector('.nd-overlay');
    const closeBtn = document.querySelector('.nd-close-btn');
    const navItems = document.querySelectorAll('.nd-nav-item[data-panel]');
    const panels   = document.querySelectorAll('.nd-panel');

    if (!drawer) return;

    /* ----------------------------------------------------------
       Interception du bouton hamburger natif du thème
       Le thème utilise <details> + <summary> + web component
       On intercepte le clic sur le <summary> hamburger
       et on empêche le comportement natif (ouverture du <details>)
    ---------------------------------------------------------- */
    const nativeSummary = document.querySelector(
      '.header__icon--summary, summary.header__icon--menu'
    );

    if (nativeSummary) {
      nativeSummary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // On s'assure que le <details> natif reste fermé
        const details = document.getElementById('Details-menu-drawer-container');
        if (details) details.removeAttribute('open');

        openDrawer();
      });
    }

    /* ----------------------------------------------------------
       Gestion des liens avec ancres — scroll forcé si même page
       Résout : clic sur #ancre quand on est déjà sur la page
    ---------------------------------------------------------- */
    document.querySelectorAll('.nd-prod-row, .nd-kit-card').forEach(function (link) {
      link.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (!href || !href.includes('#')) return;

        const parts      = href.split('#');
        const targetPath = parts[0];   // ex: /pages/habitat
        const targetHash = parts[1];   // ex: grille-30x30

        const currentPath = window.location.pathname.replace(/\/$/, '');
        const cleanTarget = targetPath.replace(/\/$/, '');

        // Si on est déjà sur la bonne page
        if (currentPath === cleanTarget || cleanTarget === '') {
          e.preventDefault();
          closeDrawer();

          const el = document.getElementById(targetHash);
          if (el) {
            setTimeout(function () {
              el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 320); // Attendre la fermeture du drawer
          }
        }
        // Sinon : navigation normale, le navigateur gère
      });
    });

    /* ----------------------------------------------------------
       Fermeture
    ---------------------------------------------------------- */
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* ----------------------------------------------------------
       Switch de panneau (colonne gauche)
    ---------------------------------------------------------- */
    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        switchPanel(this.dataset.panel);
      });
    });

    /* ----------------------------------------------------------
       Fonctions
    ---------------------------------------------------------- */
    function openDrawer() {
  drawer.classList.add('is-open');
  overlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  drawer.removeAttribute('inert');
  setTimeout(function () {
    if (closeBtn) closeBtn.focus();
  }, 350);
}

    function closeDrawer() {
  drawer.classList.remove('is-open');
  overlay.classList.remove('is-open');
  document.body.style.overflow = '';
  drawer.setAttribute('inert', '');
  resetNativeDrawer();
  if (nativeSummary) nativeSummary.focus();
}

    /* ----------------------------------------------------------
       Remise à zéro du tiroir natif du thème
       Au clic sur le hamburger, le thème marque son propre tiroir
       comme ouvert (classe « menu-open » + aria-expanded="true").
       Comme la fermeture passe par notre croix, rien ne le remet
       à zéro : le header garde la croix à la place du hamburger
       jusqu'au rechargement de la page.
    ---------------------------------------------------------- */
    function resetNativeDrawer() {
      var details = document.getElementById('Details-menu-drawer-container');
      if (details) {
        details.classList.remove('menu-open');
        details.removeAttribute('open');
      }
      if (nativeSummary) nativeSummary.setAttribute('aria-expanded', 'false');
    }

    function switchPanel(targetId) {
      navItems.forEach(function (item) {
        const isTarget = item.dataset.panel === targetId;
        item.classList.toggle('is-active', isTarget);
        item.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.id === 'nd-panel-' + targetId);
      });
    }

  });

})();